// @solana/web3.js + @solana/spl-token reference the Node `Buffer`
// global that browsers don't provide. Vite doesn't auto-polyfill it,
// so we expose it explicitly. Import this BEFORE any Solana code
// (do it as the first line of main.tsx).
import { Buffer } from "buffer";

if (typeof window !== "undefined" && !(window as { Buffer?: unknown }).Buffer) {
  (window as { Buffer: typeof Buffer }).Buffer = Buffer;
}
